import { CellphoneLinkIcon } from './CellphoneLinkIcon';

/**
 * author: Google
 * id E29A590D-51B8-471B-B23B-E0A41046EDA6
 * name cellphone-link
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-link.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MobilePhoneLinkIcon = CellphoneLinkIcon;
export default MobilePhoneLinkIcon